import { DEFAULT_LIMIT_PAGINATION } from 'constants/pagination';
import { TOptionsQuery } from 'types/common';
import { controlInitRepositories } from 'repositories/controlInit';
import { TControlInitDetail } from 'types/controlInit';

const DEFAULT_GROUPS_LIMIT = DEFAULT_LIMIT_PAGINATION;
const DEFAULT_GROUPS_PAGE = 1;

const getControlInit = async (params: TOptionsQuery<TControlInitDetail>) => {
  const res = await controlInitRepositories.getControlInit({
    condition: {
      ...params,
      limit: params.limit ?? DEFAULT_GROUPS_LIMIT,
      page: params.page ?? DEFAULT_GROUPS_PAGE,
    },
  });

  if (res instanceof Error) {
    throw res;
  }

  return res.data;
};

const getControlInitDetail = async (data: { ctrRsId: number; groupId: number }) => {
  const { ctrRsId, groupId } = data;
  const res = await controlInitRepositories.getDetailControlInit({
    condition: { groupId },
    pathParameters: { id: ctrRsId },
  });

  if (res instanceof Error) {
    throw res;
  }

  return res.data;
};

const createControlInit = async (data: { name?: string; fname?: string; groupId: number }) => {
  const { groupId, ...body } = data;
  const res = await controlInitRepositories.createControlInit({
    body,
    condition: { groupId },
  });

  if (res instanceof Error) {
    throw res;
  }

  return res.data;
};

const updateControlInit = async (data: { ctrRsId: number; name?: string; fname?: string; groupId: number }) => {
  const { ctrRsId, name, fname, groupId } = data;
  const res = await controlInitRepositories.updateControlInit({
    body: { name, fname },
    pathParameters: { id: ctrRsId },
    condition: { groupId },
  });

  if (res instanceof Error) {
    throw res;
  }

  return res.data;
};

const deleteControlInit = async (data: { ctrRsId: number; groupId: number }) => {
  const { ctrRsId, groupId } = data;
  const res = await controlInitRepositories.deleteControlInit({
    pathParameters: { id: ctrRsId },
    condition: { groupId },
  });

  if (res instanceof Error) {
    throw res;
  }

  return ctrRsId;
};

const uploadControlInitFile = async (file: FormData) => {
  const res = await controlInitRepositories.uploadControlInit({
    body: file,
  });

  if (res instanceof Error) {
    throw res;
  }

  return res.data;
};

const downloadControlInitFile = async (data: { ctrRsId: number; groupId: number }) => {
  const { ctrRsId, groupId } = data;
  const res = await controlInitRepositories.downloadControlInit({
    pathParameters: { id: ctrRsId },
    condition: { groupId },
  });

  if (res instanceof Error) {
    throw res;
  }

  return res.data;
};
export const controlInitServices = {
  getControlInit,
  getControlInitDetail,
  uploadControlInitFile,
  createControlInit,
  updateControlInit,
  deleteControlInit,
  downloadControlInitFile,
};
